import { Pivot } from 'api';
import { AppEpic } from 'model';
import { appMessageClose, appMessageError, appMessageLoading } from 'model/app';
import { combineEpics } from 'redux-observable';
import { of, forkJoin } from 'rxjs';
import { catchError, delay, filter, mergeMap, startWith, tap } from 'rxjs/operators';
import { setPersonConfig } from '.';
import APP_MESSAGE from 'constant/message';
import Grayscale from 'lib/grayscalePublishing';
import { push } from 'connected-react-router';
import APP_ROUTE from 'constant/route';

type SetPersonConfigAction = ReturnType<typeof setPersonConfig>;

const setPersonConfigEpic: AppEpic = (action$) =>
  action$.pipe(
    filter(setPersonConfig.match),
    mergeMap((action: SetPersonConfigAction) =>
      forkJoin([Pivot.setStaff(action.payload.staffId), Pivot.companyDisplayConfig(action.payload)]).pipe(
        // 使用 href 替代 push(APP_ROUTE.HOME)，进行灰发资源匹配
        mergeMap(() => of(appMessageClose()).pipe(delay(1000), Grayscale.support ? tap(() => (location.href = '/')) : startWith(push(APP_ROUTE.SCHEDULE)))),
        catchError(() => of(appMessageError(APP_MESSAGE.SET_COMPANY_REJECTED))),
        startWith(appMessageLoading(APP_MESSAGE.SET_COMPANY_PENGING))
      )
    )
  );

export type SwitchEpicActions = SetPersonConfigAction;

export default combineEpics(setPersonConfigEpic);
